// src/modules/app-views/account/pages/Init/modals/RemoveAccountModal/Step3.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const ConfirmStepContent = () => (
  <Alert
    title={translateX('attention')}
    style={{ width: '100%' }}
    description={translateX('remove_account_final_confirmation_description')}
    type="error"
    showIcon
  />
);

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const confirmStep = () => ({
  stepTitle: 'confirm',
  stepTooltip: 'final_warning',
  content: <ConfirmStepContent />,
  validationFields: [],
  nextButtonText: 'remove_my_account',
  nextButtonIcon: <DeleteOutlined />,
  nextButtonProps: { danger: true },
  isConfirmStep: true,
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default confirmStep;
